import { render } from "./CarouselBanner.vue?vue&type=template&id=1edbd8c4"
import script from "./CarouselBanner.vue?vue&type=script&lang=js"
export * from "./CarouselBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__